var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.785,
    height: 18.792,
    viewBox: "0 0 23.785 18.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30547",
    "data-name": "Group 30547",
    transform: "translate(-24021.484 66.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(24021.984 -48.196) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11844",
    "data-name": "Path 11844",
    d: "M9.747,0h1.332A2.691,2.691,0,0,1,13.77,2.691V17.373a2.691,2.691,0,0,1-2.691,2.691H2.691A2.691,2.691,0,0,1,0,17.373",
    transform: "translate(4.023 2.721)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11846",
    "data-name": "Path 11846",
    d: "M11.079,20.064H2.691A2.691,2.691,0,0,1,0,17.373V2.691A2.691,2.691,0,0,1,2.691,0h8.388A2.691,2.691,0,0,1,13.70,2.691V17.373A2.691,2.691,0,0,1,11.079,20.064Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    d: "M24011.715-62.659l6.844,6.845,6.846-6.845",
    transform: "translate(13 4)",
    fill: "none",
    stroke: "#fc8a06",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationsIcon);
export default __webpack_public_path__ + "static/media/invitationsIcon.290fd49f15c4b1d61172f93dd414b479.svg";
export { ForwardRef as ReactComponent };